'use strict';

var tslib = require('tslib');
var neverthrow = require('neverthrow');
var singleton = require('@keenondrums/singleton');
var logger = require('../../logger.js');
var authApiClient = require('../authApiClient.js');

exports.IframeUserManager = class IframeUserManager {
    _params;
    _authApiClient;
    _logger;
    _tokenSet = null;
    constructor(params) {
        this._params = params || {};
        this._authApiClient = new authApiClient.AuthApiClient({ prefix: this._params.prefix, webPath: this._params.webPath });
        this._logger = new logger.default('IframeUserManager');
    }
    /**
     * Проверяет что срок действия токена истек, если до истечения его действия осталось менее 60 секунд
     *
     * @param {number } exp - время в секундах
     */
    _checkExpiration(exp) {
        return exp - Math.round(Date.now() / 1000) < 60;
    }
    prepare() {
        return neverthrow.ok(undefined);
    }
    async sendOtpToPhoneNumber(params) {
        const { analytics } = this._params;
        try {
            await this._authApiClient.sendOTPByPhoneNumber({ ...analytics, ...params });
        }
        catch (error) {
            if (error instanceof Error) {
                this._logger.error(error.message);
                return neverthrow.err(error);
            }
        }
        return neverthrow.ok(undefined);
    }
    async getConsents(params) {
        const { analytics: { productId } = {} } = this._params;
        try {
            const data = await this._authApiClient.getConsents({ productId, ...params });
            return neverthrow.ok(data);
        }
        catch (error) {
            if (error instanceof Error) {
                this._logger.error(error.message);
                return neverthrow.err(error);
            }
            return neverthrow.err(new Error());
        }
    }
    async loginV2(params) {
        if (typeof window === 'undefined')
            return neverthrow.err(new Error('No window defined'));
        try {
            const { otac, username } = await this._authApiClient.verifyPhoneNumberByReferenceToken(params);
            const tokenSet = await this._authApiClient.getConnectTokenSet({ otac, username });
            this._tokenSet = tokenSet;
        }
        catch (error) {
            if (error instanceof Error) {
                this._logger.error(error.message);
                return neverthrow.err(error);
            }
        }
        return neverthrow.ok(undefined);
    }
    /** @deprecated Use loginV2 */
    async login(params) {
        if (typeof window === 'undefined')
            return neverthrow.err(new Error('No window defined'));
        const { analytics: { productId } = {} } = this._params;
        try {
            const { otac, username } = await this._authApiClient.verifyPhoneNumberByOTP({ productId, ...params });
            const tokenSet = await this._authApiClient.getConnectTokenSet({ otac, username });
            this._tokenSet = tokenSet;
        }
        catch (error) {
            if (error instanceof Error) {
                this._logger.error(error.message);
                return neverthrow.err(error);
            }
        }
        return neverthrow.ok(undefined);
    }
    async getAccessToken() {
        if (this._tokenSet === null)
            return neverthrow.err(new Error('User does not authenticated'));
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const { access_token, expires_at } = this._tokenSet;
        const isExpired = this._checkExpiration(expires_at);
        if (isExpired)
            return neverthrow.err(new Error('Access token is expired'));
        return neverthrow.ok(access_token);
    }
};
exports.IframeUserManager = tslib.__decorate([
    singleton.singleton
], exports.IframeUserManager);
//# sourceMappingURL=iframeUserManager.js.map
